import React, { useState } from 'react';
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, NavLink, useLocation } from 'react-router-dom';
import YourLogo from '../../Assets/Images/Pro_Logo.png';
import '../../Assets/Style/style.css';
import './sidebar.css';
import { RxHamburgerMenu } from 'react-icons/rx';
import { AiOutlineStock, AiOutlineBulb } from 'react-icons/ai';
import { TbFileInvoice } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { getCompany } from '../../../Redux/selecters';
import { FaMailBulk, FaFileInvoiceDollar, FaFileInvoice } from 'react-icons/fa';
import { MdCancel, MdOutlineUndo } from 'react-icons/md';
import { FaMoneyCheckAlt, FaCalendarCheck } from 'react-icons/fa';

const PMSideBar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const companies = useSelector(getCompany);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };
  const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  const accessibleForms = storedPermissions.filter((form) => form.canView);
  const [permissions, setPermission] = useState(accessibleForms);

  return (
    <div>
      <ProSidebar collapsed={collapsed}>
        {collapsed ? (
          // <a href="/Inventory" className="navbar-brand start">
          //   <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '40px', paddingTop: '8px', paddingBottom: '8px' }} />
          // </a>
          ""
        ) : (
          <a href="/" className="navbar-brand start">
            <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '90px' }} />
            {/* <span className="logoName" style={{ marginLeft: '8px' }}>
              {companies?.selectedCompany?.logo?.split('/').pop()?.split('.').slice(0, -1).join('.')?.charAt(0).toUpperCase() +
                companies?.selectedCompany?.logo?.split('/').pop()?.split('.').slice(0, -1).join('.')?.slice(1).toLowerCase()}
            </span> */}
          </a>
        )}
        <Menu className="mt-2">
          {permissions?.some((permission) => permission.formName === 'Dashboard' && permission.canView) && (
            <MenuItem
              icon={<AiOutlineStock size={23} />}
              active={location.pathname === '/'}
            >
              <NavLink to="/">
                <div>DashBoard</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Lease Agreement ' && permission.canView) && (
            <MenuItem icon={<AiOutlineBulb size={23} />} active={location.pathname.startsWith('/Property/Management/LeaseAgreement')}>
              <NavLink to="/Property/Management/LeaseAgreement">
                <div className={`submenu ${location.pathname === '/Property/Management/LeaseAgreement' ? 'subactive' : ''}`}>Lease Agreement</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Single Invoice' && permission.canView) && (
            <MenuItem icon={<TbFileInvoice size={23} />} active={location.pathname.startsWith('/Property/Management/Single/Invoice')}>
              <NavLink to="/Property/Management/Single/Invoice/Listing">
                <div className={`submenu ${location.pathname === '/Property/Management/Single/Invoice' ? 'subactive' : ''}`}>Single Invoice</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Installment Invoice' && permission.canView) && (
            <MenuItem icon={<FaFileInvoiceDollar size={23} />} active={location.pathname.startsWith('/Property/Management/Installment/Invoice')}>
              <NavLink to="/Property/Management/Installment/Invoice/Listing">
                <div className={`submenu ${location.pathname === '/Property/Management/Installment/Invoice' ? 'subactive' : ''}`}>Installment Invoice</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Lease Receipt' && permission.canView) && (
            <MenuItem
              icon={<FaFileInvoice size={23} />}
              active={location.pathname.startsWith('/Lease/Management/Lease/Receipt/')}
            >
              <NavLink to="/Lease/Management/Lease/Receipt/Listing">
                <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Receipt/" ? 'subactive' : ''}`}>Lease Receipt</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Lease Reverse Receipt' && permission.canView) && (
            <MenuItem
              icon={<MdOutlineUndo size={23} />}
              active={location.pathname.startsWith('/Property/Management/Lease/Reverse/')}
            >
              <NavLink to="/Property/Management/Lease/Reverse/Receipt">
                <div className={`submenu ${location.pathname === "/Property/Management/Lease/Reverse/" ? 'subactive' : ''}`}>Lease Reverse Receipt</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Termination' && permission.canView) && (
            <MenuItem icon={<MdCancel size={23} />} active={location.pathname.startsWith('/Property/Management/Lease/Termination')}>
              <NavLink to="/Property/Management/Lease/Termination/Listing">
                <div className={`submenu ${location.pathname === '/Property/Management/Lease/Termination' ? 'subactive' : ''}`}>Lease Termination</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Manage Payment' && permission.canView) && (
            <MenuItem icon={<FaMoneyCheckAlt size={23} />} active={location.pathname.startsWith('/Property/Management/Lease/Payment/Management')}>
              <NavLink to="/Property/Management/Lease/Payment/Management">
                <div className={`submenu ${location.pathname === '/Property/Management/Lease/Payment/Management' ? 'subactive' : ''}`}>Manage Payment</div>
              </NavLink>
            </MenuItem>
            // <MenuItem icon={<FaCalendarCheck size={23} />} active={location.pathname.startsWith('/Property/Management/Lease/Reservation/')}>
            //   <NavLink to="/Property/Management/Lease/Reservation/Listing">
            //     <div className={`submenu ${location.pathname === '/Property/Management/Lease/Reservation/' ? 'subactive' : ''}`}>Lease Reservation</div>
            //   </NavLink>
            // </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Lease Bulk Receipt' && permission.canView) && (
            <MenuItem icon={<FaMailBulk size={23} />} active={location.pathname.startsWith('/Property/Management/Lease/Bulk/Receipt')}>
              <NavLink to="/Property/Management/Lease/Bulk/Receipt/Listing">
                <div className={`submenu ${location.pathname === '/Property/Management/Lease/Bulk/Receipt/Listing' ? 'subactive' : ''}`}>
                  Lease Bulk Receipt
                </div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some((permission) => permission.formName === 'Lease Revenue' && permission.canView) && (
            <MenuItem icon={<FaMailBulk size={23} />} active={location.pathname.startsWith('/Property/Management/Lease/RevenuePosting')}>
              <NavLink to="/Property/Management/Lease/RevenuePosting">
                <div className={`submenu ${location.pathname === '/Property/Management/Lease/RevenuePosting' ? 'subactive' : ''}`}>
                  Lease Revenue Posting
                </div>
              </NavLink>
            </MenuItem>
          )}
        </Menu>

        <div onClick={handleToggle} className="sidebar-toggle-btn" style={{ left: collapsed ? '120px' : '380px' }}>
          <RxHamburgerMenu size={32} />
        </div>
      </ProSidebar>
    </div>
  );
};

export default PMSideBar;
